import { isNil } from 'lodash-es';
import { useContext } from 'react';

import { ModuleLoaderContext } from './ModuleLoaderProvider';

const useModuleLoader = () => {
  const ctx = useContext(ModuleLoaderContext);

  if (isNil(ctx)) {
    throw new Error('useModuleLoader must be used within a ModuleLoaderProvider!');
  }

  return ctx;
};

export default useModuleLoader;
